import React from "react";

/** Small spinner for buttons and table rows; inherits the text colour. */
const InlineSpinner = ({ className = "size-3.5" }) => (
  <span
    aria-hidden="true"
    className={`inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
  />
);

export default InlineSpinner;
